// react
import React from "react";

// MATERIAL-UI
import { Grid, Typography } from "@mui/material";

// COMPONENTS

// ASSESTS
import { FilterCardStyles } from "./styles/filterCard.styles";
import { FilterCardProps } from "./types";
import Preloader from "src/utils/Preloader";
import { trackEvent } from "src/Amplitude";

const FilterCard = (props: FilterCardProps) => {
  const classes = FilterCardStyles();

  return (
    <Grid container className={classes.container}>
      {props.items.length <= 0 ? (
        <Grid item container justifyContent="center" className={classes.preloader}>
          <Preloader />
        </Grid>
      ) : (
        <>
          {props.items.map((item) => (
            <Grid key={item} item xs={12} container>
              <Grid item xs={12} className={classes.itemList} onClick={() => props.setValue(item)}>
                <Typography
                  onClick={() =>
                    trackEvent(`Select_Markets_Page_Select_Sector`, {
                      item,
                    })
                  }
                  className={classes.item}>
                  {item}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </>
      )}
    </Grid>
  );
};

export default FilterCard;
